export default [
  {
    path: '/report',
    name: 'Report',
    component: () =>
      import(/* webpackChunkName: "report" */ '../layout/ReportLayout.vue'),
    children: [
      {
        path: 'product',
        name: 'product',
        component: () =>
          import(
            /* webpackChunkName: "report" */ '../views/report/prodRecommend.vue'
          ),
      },
      {
        path: 'dietary',
        name: 'dietary',
        component: () =>
          import(
            /* webpackChunkName: "report" */ '../views/report/dietarySuggestion.vue'
          ),
      },
      {
        path: 'special',
        name: 'special',
        component: () =>
          import(
            /* webpackChunkName: "report" */ '../views/report/specialRemind.vue'
          ),
      },
    ],
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/report/htmlPDF.vue'),
  },
  {
    path: '/excessive',
    name: 'excessive',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/report/excessivePage.vue'
      ),
  },
  {
    path: '/introduction',
    name: 'introduction',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/report/introduction.vue'
      ),
  },
]
